<template>
  <div>
    <div class="text-3xl mb-8">Veranstaltungen</div>

    <ais-instant-search
      v-if="currentAccount.id"
      index-name="discovery"
      :search-client="searchClient"
      :routing="routing"
    >
      <ais-configure :tag-filters.camel="['event']" :filters="filters" />

      <div class="items-center flex justify-between">
        <ais-search-box class="w-1/2">
          <template slot-scope="{ currentRefinement, refine }">
            <input
              placeholder="Tippen zum suchen..."
              type="search"
              :value="currentRefinement"
              class="border rounded py-3 px-6 text-gray-800 outline-none w-full"
              @input="refine($event.currentTarget.value)"
            />
          </template>
        </ais-search-box>

        <ais-sort-by class="w-1/4" :items="sortByItems">
          <template slot-scope="{ items, currentRefinement, refine }">
            <multiselect
              :options="items"
              :searchable="false"
              :value="currentRefinement"
              @input="refine($event)"
            >
              <template slot="beforeList">
                <div class="m-3 text-grey-darker font-semibold">Sortieren nach</div>
              </template>
            </multiselect>
          </template>
        </ais-sort-by>
      </div>

      <ais-state-results>
        <template slot-scope="{ hits }">
          <ais-infinite-hits>
            <div slot-scope="{ items, isLastPage, refineNext }">
              <router-link
                v-for="event in items"
                :key="event.id"
                :to="{ name: 'event.tickets', params: { id: event.id } }"
                class="flex my-4 p-4 rounded text-black shadow"
              >
                <div class="mr-4 w-24">
                  <img class="rounded" v-if="event.media.logo" :src="event.media.logo.url" />
                </div>
                <div class="flex w-full justify-between">
                  <div>
                    <div class="text-xl leading-none">{{ event.title }}</div>

                    <div class="text-gray-700 mt-2">{{ event.start_date.local | date }} Uhr</div>
                    <div class="text-gray-700 mb-2">
                      {{ event.venue.name }} - {{ event.venue.city }}
                    </div>
                  </div>
                  <slot></slot>
                </div>
              </router-link>

              <button class="btn btn-primary btn-outline" v-show="!isLastPage" @click="refineNext">
                Mehr zeigen
              </button>
            </div>
          </ais-infinite-hits>

          <div v-show="hits.length < 1" class="py-8 text-center">
            <div class="flex justify-center">
              <img class="max-w-sm" src="../assets/images/notasks73.svg" alt="Nothing found" />
            </div>

            <div class="text-2xl mt-6">Keine Veranstaltungen gefunden</div>
          </div>
        </template>
      </ais-state-results>
    </ais-instant-search>
  </div>
</template>

<script>
import { history } from 'instantsearch.js/es/lib/routers';
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings';
import Multiselect from '@/components/Multiselect';
import algoliasearch from 'algoliasearch/lite';
import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
dayjs.extend(utcPlugin);

export default {
  components: {
    Multiselect,
  },

  computed: {
    currentAccount() {
      return this.$store.state.account.currentAccount;
    },
    filters() {
      const publishedTimeFilter = `published_from_timestamp<${this.now()} AND published_to_timestamp>${this.now()}`;
      const organizerFilter = this.currentAccount.linked_organizer_id
        ? ` AND organizer_id=${this.currentAccount.linked_organizer_id}`
        : '';

      return publishedTimeFilter + organizerFilter;
    },
  },

  filters: {
    date(value) {
      return dayjs(value).format('dddd, DD MMMM YYYY HH:mm');
    },
  },

  data() {
    const vueRouter = this.$router;

    const routing = {
      router: {
        read() {
          return vueRouter.currentRoute.query;
        },
        write(routeState) {
          vueRouter.push({
            query: routeState,
          });
        },
        createURL(routeState) {
          return vueRouter.resolve({
            query: routeState,
          }).href;
        },
        onUpdate(cb) {
          if (typeof window === 'undefined') return;

          this._removeAfterEach = vueRouter.afterEach(() => {
            cb(this.read());
          });

          this._onPopState = () => {
            cb(this.read());
          };
          window.addEventListener('popstate', this._onPopState);
        },
        dispose() {
          if (typeof window === 'undefined') {
            return;
          }
          if (this._onPopState) {
            window.removeEventListener('popstate', this._onPopState);
          }
          if (this._removeAfterEach) {
            this._removeAfterEach();
          }
        },
      },
    };

    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_CLIENT_ID,
        process.env.VUE_APP_ALGOLIA_SEARCH_KEY
      ),
      routing,
      sortByItems: [
        { value: 'discovery_sort_by_date_asc', label: 'Datum aufsteigend' },
        { value: 'discovery_sort_by_date_desc', label: 'Datum absteigend' },
        { value: 'discovery', label: 'Relevanz' },
        { value: 'discovery_sort_by_venue', label: 'Eventort' },
      ],
    };
  },
  methods: {
    now() {
      return dayjs.utc().unix();
    },
  },
};
</script>